import styled from 'styled-components';
import { Col } from 'antd';

interface ScoreComponentProps {
	isFinalScore: boolean;
}

export const ScoreComponent = styled.div<ScoreComponentProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0.5rem;
	width: 100%;
	border: 2px solid;
	padding: 0.9rem;
	&::after {
		content: '';
		position: absolute;
		top: -4px;
		left: 50%;
		transform: translateX(-50%) translateY(50%);
		width: 0;
		height: 0;
		border-top: 0.5rem solid white;
		border-left: 0.5rem solid transparent;
		border-right: 0.5rem solid transparent;
		display: ${({ isFinalScore }) => (isFinalScore ? 'block' : 'none')};
	}
	h2 {
		margin: 0;
		line-height: 1;
		font-weight: bold;
		text-align: center;
	}
`;

export const StyledCol = styled(Col)`
	display: flex;
	margin: 0 !important;
	padding: 0 !important;
	justify-content: center;
`;
